import GoogleMapReact from "google-map-react";

function StoreMarker({ name }) {
  return (
    <div
      title={name}
      style={{
        position: "absolute",
        transform: "translate(-50%, -100%)",
        cursor: "default",
      }}
    >
      <div
        style={{
          width: 30,
          height: 30,
          borderRadius: "50% 50% 50% 0",
          transform: "rotate(-45deg)",
          background: "#ffffff",
          border: "3px solid #be1a1a",
          boxShadow: "0 3px 10px rgba(0, 0, 0, 0.3)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            width: 9,
            height: 9,
            borderRadius: "50%",
            background: "#be1a1a",
            transform: "rotate(45deg)",
          }}
        />
      </div>
    </div>
  );
}

export default function Map({ locations = [] }) {
  const center = {
    lat: 55.858,
    lng: -4.259,
  };

  const stores = locations
    .map((location) => {
      const lat = Number(location?.Address?.latitude);
      const lng = Number(location?.Address?.longitude);

      if (!location?.name || !Number.isFinite(lat) || !Number.isFinite(lng)) {
        return null;
      }

      return {
        name: location.name,
        position: { lat, lng },
      };
    })
    .filter(Boolean);

  return (
    <GoogleMapReact
      bootstrapURLKeys={{
        key: "AIzaSyCA17XufYl3oox1qRT6aXvvM8JqmyvGC1I",
      }}
      center={center}
      defaultCenter={center}
      defaultZoom={11}
      options={{
        fullscreenControl: false,
        streetViewControl: false,
        mapTypeControl: false,
        zoomControl: true,
      }}
    >
      {stores.map((store) => (
        <StoreMarker
          key={store.name}
          lat={store.position.lat}
          lng={store.position.lng}
          name={store.name}
        />
      ))}
    </GoogleMapReact>
  );
}
